// console.log("1aaaaaaaaaaaaa");
// const movieBtn = document.getElementById("js--modal-btn");
// const movie = document.getElementById("js--movie-iframe");

// window.onload = function() {
//     movieBtn.addEventListener("click", () => {
//         console.log("2aaaaaaaaaaaaa");
//     });
// };

//モーダル
document.addEventListener("DOMContentLoaded", () => {
    // ウィンドウを開く
    const modalBtn = document.getElementsByClassName("js--modal-btn");
    for (let i = 0; i < modalBtn.length; i++) {
        modalBtn[i].addEventListener("click", () => {
            const target = modalBtn[i].dataset.target;
            const modal = document.getElementById(target);
            modal.classList.add("js--modal-open");
        });
    }

    // ウィンドウを閉じる
    const modalClose = document.getElementsByClassName("js--modal-close");
    for (let i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener("click", () => {
            const target = modalClose[i].closest(".js--modal-open");
            target.classList.remove("js--modal-open");
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const header = document.getElementById("shopify-section-header");
    const header_h = header.clientHeight;
    // const body = document.body;
    // console.log(header_h);
    // body.classList.add("aaa");

    // スムーススクロール -------------------------
    const smoothScroll = () => {
        const links = document.querySelectorAll('a[href^="#"]');
        const speed = 200; // スクロールスピード
        const divisor = 100; // 分割数
        const tolerance = 5; // 許容誤差
        const headerHeight = 0; // 固定ヘッダーがある場合はその高さ分ずらす
        const interval = speed / divisor;
        for (let i = 0; i < links.length; i++) {
            links[i].addEventListener("click", e => {
                e.preventDefault();
                const nowY = window.pageYOffset;
                const href = e.currentTarget.getAttribute("href");
                const target = document.querySelector(href);
                if (null != target) {
                    const targetRectTop = target.getBoundingClientRect().top;
                    const targetY = targetRectTop + nowY - headerHeight;
                    const minY = Math.abs((targetY - nowY) / divisor);
                    doScroll(minY, nowY, targetY, tolerance, interval);
                }
            });
        }
    };

    const doScroll = (minY, nowY, targetY, tolerance, interval) => {
        let toY;
        if (targetY < nowY) {
            toY = nowY - minY;
        } else {
            toY = nowY + minY;
        }
        window.scrollTo(0, toY);
        if (targetY - tolerance > toY || toY > targetY + tolerance) {
            window.setTimeout(doScroll, interval, minY, toY, targetY, tolerance, interval);
        } else {
            return false;
        }
    };

    // 関数実行 -------------------------
    smoothScroll();
    //
});

// document.addEventListener("DOMContentLoaded", () => {
//     // 言語切り替え
//     const lang_value = document.documentElement.lang;
//     const header_txt = document.getElementById("js--accordion-head-txt");
//     const header_img = document.getElementById("js--accordion-head-img");

//     if ("ja" === lang_value) {
//         header_txt.innerHTML = "日本語";
//         header_img.src =
//             "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/ja.svg";
//         document.getElementById("js--lang-jp").remove();
//     } else if ("en" === lang_value) {
//         header_txt.innerHTML = "English";
//         header_img.src =
//             "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/en.svg";
//         document.getElementById("js--lang-en").remove();
//     } else if ("zh-CN" === lang_value) {
//         header_txt.innerHTML = "Chinese (China)";
//         header_img.src =
//             "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/zh-CN.svg";
//         document.getElementById("js--lang-zh-cn").remove();
//     } else {
//     }
// });

document.addEventListener("DOMContentLoaded", () => {
    // 言語切り替え
    const lang_value = document.documentElement.lang;
    const header_txt = document.getElementsByClassName("js--accordion-head-txt");
    const header_img = document.getElementsByClassName("js--accordion-head-img");

    const lang_jp = document.getElementsByClassName("js--lang-jp");
    const lang_en = document.getElementsByClassName("js--lang-en");
    const lang_zh_cn = document.getElementsByClassName("js--lang-zh-cn");

    if ("ja" === lang_value) {
        for (let i = 0; i < header_txt.length; i++) {
            header_txt[i].innerHTML = "日本語";
        }
        for (let i = 0; i < header_img.length; i++) {
            header_img[i].src =
                "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/ja.svg";
        }
        for (let i = lang_jp.length - 1; 0 < i; i--) {
            lang_jp[i].remove();
        }
    } else if ("en" === lang_value) {
        for (let i = 0; i < header_txt.length; i++) {
            header_txt[i].innerHTML = "English";
        }
        for (let i = 0; i < header_img.length; i++) {
            header_img[i].src =
                "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/en.svg";
        }
        for (let i = lang_en.length - 1; 0 < i; i--) {
            lang_en[i].remove();
        }
    } else if ("zh-CN" === lang_value) {
        for (let i = 0; i < header_txt.length; i++) {
            header_txt[i].innerHTML = "中文简体字";
        }
        for (let i = 0; i < header_img.length; i++) {
            header_img[i].src =
                "https://cdn.langshop.app/buckets/app/img/svg/languages/flags/rectangle/zh-CN.svg";
        }
        for (let i = lang_zh_cn.length - 1; 0 < i; i--) {
            lang_zh_cn[i].remove();
        }
    }
});

document.addEventListener("DOMContentLoaded", () => {
    //アコーディオンクリック
    const accordion = document.getElementsByClassName("accordion-item");
    for (let i = 0; i < accordion.length; i++) {
        accordion[i].addEventListener("click", () => {
            accordion[i].classList.toggle("accordion--open");
        });
    }
});
